import { ArrowRight, FileText } from 'lucide-react';
import { blogTopics } from '../data/site';

type Page = 'home' | 'services' | 'case-studies' | 'industries' | 'about' | 'insights' | 'contact';

export function Insights({ onNavigate }: { onNavigate: (page: Page) => void }) {
  return (
    <section className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
      <div className="max-w-4xl">
        <p className="section-eyebrow">Blog / Insights</p>
        <h1 className="section-title">Technical-commercial content for enterprise platform buyers.</h1>
        <p className="mt-5 text-lg leading-8 text-slate-600">
          These topics are positioned to attract inbound consulting leads from organisations planning API-first,
          cloud-native, secure, and AI-ready platform work.
        </p>
      </div>

      <div className="mt-10 grid gap-4 md:grid-cols-3">
        {blogTopics.map((topic) => (
          <article key={topic} className="rounded border border-slate-200 bg-white p-5 shadow-soft">
            <FileText className="text-cyan" size={24} aria-hidden="true" />
            <h2 className="mt-4 text-lg font-bold">{topic}</h2>
            <p className="mt-3 text-sm leading-6 text-slate-600">
              A practical article topic for enterprise leaders evaluating architecture, governance, delivery risk, and
              modernisation investment.
            </p>
          </article>
        ))}
      </div>

      <div className="mt-10 rounded bg-ink p-8 text-white">
        <h2 className="text-2xl font-bold">Want to turn one of these into a lead magnet?</h2>
        <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-300">
          Start with an API-first architecture guide, cloud assessment checklist, or AI-ready API platform briefing.
        </p>
        <button className="btn-primary mt-6" onClick={() => onNavigate('contact')}>
          Discuss content-led consulting <ArrowRight size={18} aria-hidden="true" />
        </button>
      </div>
    </section>
  );
}
